module.exports = __webpack_public_path__ + "static/media/recipes.db9f55ea.svg";